import React, {Component} from 'react';
import {InputItem, Modal,Toast} from 'antd-mobile';
import {bindPhone} from '../../service/homeService';
import storage from '../../utils/localStore';

import "./style.less";
const phoneReg = /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/;
export default class ExigencyPep extends Component {
    constructor(props) {
        super(props);
        this.state = {
            phone:'',
            name:'',

        };
    }
    componentDidMount() {
        // console.log(this.props)
    }
    inputChange = (v, key) => {
        this.setState({[key]: v,});
    };

    exigencyBtn = () => {
        if(this.state.name === ''){
            Toast.fail('请输入姓名', 2);
        }else if (!phoneReg.test(this.state.phone.replace(/\s/ig, ''))) {
            Toast.fail('请输入正确的手机号', 2);
        } else {
            Toast.loading("",0);
            let params = {
                source:1,
                token:this.props.userInfo.token,
                data:{
                    phone: this.state.phone.replace(/\s/ig, ''),
                    userName: this.state.name,
                }
            };
            this.props.exigencyClick(params)
        }
        // this.props.exigencyClick()

    };
    render(){
        return(
            <Modal
                popup
                className="exigencyModal"
                visible={this.props.modal}
                // onClose={() => this.props.onClose()}
            >
                <div className="content">
                    <div className="bar"></div>
                    {/*{this.props.detele ?
                        <div className="top" onClick={()=>this.props.onClose()}>设置紧急联系人  <span>关闭</span>  </div>
                        :<div className="top">设置紧急联系人</div>
                    }*/}
                    <div className="top" onClick={()=>this.props.onClose("first")}>设置紧急联系人  <span>关闭</span>  </div>
                    <p>为了保证您的出行安全，请设置真实有效的紧急联系人。</p>
                    <div className="middle">
                        <InputItem
                            clear
                            placeholder="请输入姓名"
                            value={this.state.name}
                            onChange={v => this.inputChange(v, 'name')}
                            onBlur={v => window.scroll(0,0)}
                        >
                            姓名:
                        </InputItem>
                        <InputItem
                            clear
                            type="phone"
                            placeholder="请输入手机号"
                            value={this.state.phone}
                            onChange={v => this.inputChange(v, 'phone')}
                            onBlur={v => window.scroll(0,0)}
                        >
                            手机号:
                        </InputItem>
                    </div>
                    <div className="bottom" onClick={this.exigencyBtn}>完成</div>
                </div>

            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ExigencyPep/index.js